// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1_RVg","cls2":"ImpactHubModal-cls2_NUj ImpactHubModal-cls1_RVg"};